import { connect } from 'react-redux'

import * as api from '@rushplay/api-client'

import { PasswordRecovery as Component } from './password-recovery'

export const PasswordRecovery = connect(
  null,
  dispatch => ({
    onSubmit: email => dispatch(api.resetPassword(email, { version: 1 })),
  })
)(Component)

// For @loadable/components
export default PasswordRecovery
